import React from 'react';
import { Wrapper } from './Root.parts';

export const Root = ({ children }: { children: React.ReactNode }) => {
  return <Wrapper>{children}</Wrapper>;
};
